module.exports = __webpack_public_path__ + "images/good-beef-index_c06e716.svg";